/**
 * Account Billing tab (formerly Accounting): Invoices and Payment Methods sub-tabs.
 * `?sub=payment-methods` opens the Payment Methods sub-tab directly.
 */
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Paper, Tab, Tabs, Typography } from '@mui/material';
import { CreditCard as PaymentIcon, Receipt as InvoicesIcon } from '@mui/icons-material';
import AccountPaymentMethodsTab from './AccountPaymentMethodsTab';

const SUB_TABS = ['invoices', 'payment-methods'] as const;
type SubTab = (typeof SUB_TABS)[number];

const AccountBillingTab: React.FC<{ accountId: string }> = ({ accountId }) => {
  const [searchParams] = useSearchParams();
  const fromQuery = searchParams.get('sub') as SubTab | null;
  const [sub, setSub] = useState<SubTab>(fromQuery && SUB_TABS.includes(fromQuery) ? fromQuery : 'invoices');

  return (
    <Box>
      <Tabs value={sub} onChange={(_, v: SubTab) => setSub(v)} sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }} aria-label="Billing sections">
        <Tab value="invoices" icon={<InvoicesIcon />} iconPosition="start" label="Invoices" />
        <Tab value="payment-methods" icon={<PaymentIcon />} iconPosition="start" label="Payment Methods" />
      </Tabs>
      {sub === 'invoices' && (
        <Paper variant="outlined" sx={{ p: 3 }}>
          <Typography color="text.secondary">Invoice information will appear here.</Typography>
        </Paper>
      )}
      {sub === 'payment-methods' && <AccountPaymentMethodsTab accountId={accountId} />}
    </Box>
  );
};

export default AccountBillingTab;
